import type { FeedbackRecord } from '@feedback-system/types';
import { StatusBadge } from './StatusBadge';
import { SeverityBadge } from './SeverityBadge';
import { ProviderBadge } from './ProviderBadge';
import { ScreenshotPreview } from './ScreenshotPreview';
import { getScreenshotUrl } from '../api';

interface FeedbackCardProps {
  feedback: FeedbackRecord;
  onClick?: () => void;
}

export function FeedbackCard({ feedback, onClick }: FeedbackCardProps) {
  const date = new Date(feedback.createdAt);
  const dateStr = date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div
      onClick={onClick}
      className="card cursor-pointer hover:border-accent-primary transition-colors"
    >
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Screenshot Thumbnail */}
        {feedback.screenshotUrl && (
          <div>
            <ScreenshotPreview url={getScreenshotUrl(feedback.id)} thumbnailMode />
          </div>
        )}

        {/* Main Content */}
        <div className={feedback.screenshotUrl ? 'md:col-span-3' : 'md:col-span-4'}>
          <div className="flex items-start justify-between mb-2">
            <p className="text-sm text-dark-200 flex-1 pr-2">{dateStr}</p>
            <StatusBadge status={feedback.status} />
          </div>

          <p className="text-dark-100 font-medium line-clamp-2 mb-3">{feedback.description}</p>

          <p className="text-xs text-dark-200 mb-3 truncate">{feedback.url}</p>

          <div className="flex flex-wrap gap-2">
            <SeverityBadge severity={feedback.severity} />
            <ProviderBadge provider={feedback.aiProvider} status={feedback.aiStatus} />
          </div>

          {feedback.aiSummary && (
            <p className="text-xs text-dark-200 mt-3 line-clamp-2">{feedback.aiSummary}</p>
          )}
        </div>
      </div>
    </div>
  );
}
